import React, { useEffect, useState } from 'react';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { KKuTuIOApi } from '../../../KKuTuIOApi';
import { BulkWordNotice, BulkWordSection, ExpandableWordList, FailureList } from './BulkWordCommon';
import './BulkWord.scss';

const valueText = values => values && values.length ? values.join(', ') : '없음';

const BulkWordModifyConfirmModal = ({ isOpen, lang, preview, request, onToggle, onShowToast, onComplete }) => {
  const [isSaving, setSaving] = useState(false);
  const [result, setResult] = useState(null);
  useEffect(() => { setSaving(false); setResult(null); }, [isOpen, preview]);
  if (!preview) return null;

  const lines = preview.changedItems.map(item => [
    item.word,
    valueText(item.oldFlags) !== valueText(item.newFlags) ? `  플래그: ${valueText(item.oldFlags)} → ${valueText(item.newFlags)}` : null,
    valueText(item.oldThemes) !== valueText(item.newThemes) ? `  주제: ${valueText(item.oldThemes)} → ${valueText(item.newThemes)}` : null,
    valueText(item.oldTypes) !== valueText(item.newTypes) ? `  품사: ${valueText(item.oldTypes)} → ${valueText(item.newTypes)}` : null,
    valueText(item.oldDefinitions) !== valueText(item.newDefinitions) ? `  단어 설정: ${valueText(item.oldDefinitions)} → ${valueText(item.newDefinitions)}` : null
  ].filter(Boolean).join('\n'));

  const handleSave = () => {
    if (isSaving || !preview.changedItems.length) return;
    setSaving(true);
    KKuTuIOApi.post(`/words/${lang}/bulk-modify`, request).then(({ data }) => {
      if (!data.success) { onShowToast('error', `${data.resultMessage} (${data.resultCode})`); return; }
      setResult(data.data);
      onShowToast('success', `${data.data.updatedCount}개의 단어를 수정했습니다.`);
      if (!data.data.failures.length) { onToggle(); onComplete(); }
    }).catch(error => onShowToast('error', `대량 수정 중 오류가 발생했습니다: ${error.message || error}`))
      .finally(() => setSaving(false));
  };

  return <Modal isOpen={isOpen} toggle={onToggle} modalClassName="ltr-support" className="modal-dialog--warning modal-dialog--header bulk-word-modal">
    <div className="modal__header"><button className="lnr lnr-cross modal__close-btn" type="button" onClick={onToggle}/><h4 className="text-modal modal__title">단어 대량 수정 - 최종 확인</h4></div>
    <div className="modal__body">{result ? <><BulkWordNotice color={result.failures.length ? 'warning' : 'success'}>요청 {result.requestedCount}건 중 {result.updatedCount}건을 수정하고 {result.skippedCount}건을 건너뛰었습니다.</BulkWordNotice><FailureList failures={result.failures}/></> : <>
      <div className="bulk-word-summary"><h4>총 {preview.changedItems.length}개의 단어를 수정합니다.</h4></div>
      <BulkWordSection title="변경 내용" count={preview.changedItems.length} text={lines.join('\n')} onCopied={() => onShowToast('success', '변경 내용을 복사했습니다.')}><ExpandableWordList lines={lines} limit={15}/></BulkWordSection>
      {preview.unchangedWords.length > 0 && <BulkWordSection title="변경 없음" count={preview.unchangedWords.length}><ExpandableWordList lines={preview.unchangedWords}/></BulkWordSection>}
      {preview.duplicateInputWords.length > 0 && <BulkWordNotice color="warning">중복 입력 {preview.duplicateInputWords.length}개를 제거했습니다.</BulkWordNotice>}
      <FailureList failures={preview.failures}/><h5 className="bulk-word-final-question">표시된 변경 사항을 적용하시겠습니까?</h5>
    </>}</div>
    <ButtonToolbar className="modal__footer"><Button className="modal_cancel" onClick={onToggle} disabled={isSaving}>{result ? '닫기' : '작업 취소'}</Button>{!result && <Button className="modal_ok" color="warning" onClick={handleSave} disabled={isSaving || !preview.changedItems.length}>{isSaving ? '수정 중...' : '계속'}</Button>}</ButtonToolbar>
  </Modal>;
};

export default BulkWordModifyConfirmModal;
